import React, { CSSProperties } from 'react';

export const CartTotalSummaryItemTestId = 'carttotalsummaryitem-content';

export type CartTotalSummaryItemProps = {
  children: string;
  formattedAmount: string;
  bold?: boolean;
  className?: string;
};

const CartTotalSummaryItem: React.FC<CartTotalSummaryItemProps> = ({
  children,
  formattedAmount,
  bold = false,
  className = '',
}: CartTotalSummaryItemProps) => {
  const customStyles: CSSProperties = { color: 'inherit' };
  return (
    <div
      data-testid={CartTotalSummaryItemTestId}
      className={`${className} ${bold ? 'font-semibold' : ''}`}
      style={customStyles}
    >
      <span>{children}</span>
      <span className="float-right">{formattedAmount}</span>
    </div>
  );
};

export default CartTotalSummaryItem;
